const React = require('react');
const T = require('prop-types');
const { default: Styled } = require('styled-components');
const { default: Paper } = require('@mui/material/Paper');
const { default: FlatButton } = require('@mui/material/Button');

const Colors = require('styles/colors.json');
const Fonts = require('styles/fonts.json');
const { ELEMENT_IDS } = require('utils/constants');

const internals = {
    height: 72
};

module.exports = function BottomButton(props) {

    const {
        label,
        onClick,
        className,
        bottomButtonContent,
        hide,
        ...rest
    } = props;

    const {
        styles,
        Wrapper,
        StyledPaper,
        ButtonContentWrapper,
        ButtonWrapper,
        StyledFlatButton
    } = internals;

    return (
        <Wrapper className={className ? className : ''}>
            <StyledPaper
                id={ELEMENT_IDS.bottomButton}
                elevation={0}
                style={{
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0
                }}
            >
                {bottomButtonContent &&
                    <ButtonContentWrapper>
                        {bottomButtonContent}
                    </ButtonContentWrapper>
                }
                {!bottomButtonContent && !hide &&
                    <ButtonWrapper>
                        <StyledFlatButton
                            color={'primary'}
                            onClick={onClick}
                            fullWidth
                            {...rest}
                            style={{ ...styles.button, ...styles.buttonLabel }}
                            data-focus-outline='radius:8,padding:4'
                        >
                            {label}
                        </StyledFlatButton>
                    </ButtonWrapper>
                }
            </StyledPaper>
        </Wrapper>
    );
};

module.exports.propTypes = {
    label: T.string,
    onClick: T.func,
    bottomButtonContent: T.any,
    className: T.string,
    classes: T.object,
    disabled: T.bool,
    form: T.string,
    hide: T.bool,
    type: T.oneOf(['button', 'submit', 'reset'])
};

internals.Wrapper = Styled.div`
    width: 100%;
    transition: height 0.2s ease-out !important;
`;

internals.StyledPaper = Styled(Paper)`
    // z-index here is set to 2 so it can hide behind
    // ":global(.contentWrapper).tabsWrapper" (z-index: 3) when sliding down
    // while also staying above the form fields in UserInputs
    // found in src/layouts/AppLayout/styles.scss
    z-index: 2;

    height: 72px;
    width: 100%;

    display: flex;
    justify-content: center;

    background-color: ${({ theme }) => theme.palette.primary.main};

    // .contentWrapper
    margin: 0 auto;
    @media screen and (min-width: 360px) {
        max-width: 400px;
    }

    @media screen and (min-width: 600px) {
        max-width: 600px;
    }

    button:hover, div[role="button"]:hover {
        opacity: 0.9;
        & > div > div {
            background-color: initial !important;
            opacity: 1;
        }
    }
`;

internals.ButtonWrapper = Styled.div`
    display: flex;
    align-items: center;
    text-align: center;
    width: 300px;

    @media screen and (max-width: 599px) {
        width: 250px;
    }
`;

internals.ButtonContentWrapper = Styled.div`
    display: flex;
    align-items: center;
    text-align: center;

    width: 100%;
    max-width: 600px;

    @media screen and (max-width: 599px) {
        width: 250px;
    }
`;

internals.StyledFlatButton = Styled(FlatButton)`
    background-color: ${({ theme }) => theme.palette.primary.contrastText};
    height: 2.25em;
    border-radius: 8px;

    font-family: ${Fonts.headerFont};
    font-weight: bold;
    text-transform: none;
    font-size: 1.25em;
    letter-spacing: 1;
    line-height: 2.5em;
`;

internals.styles = {
    button: {
        backgroundColor: Colors.lightText,
        height: '2.25em',
        borderRadius: 8
    },
    buttonLabel: {
        fontFamily: Fonts.headerFont,
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: '1.25em',
        letterSpacing: 1,
        lineHeight: '2.5em'
    }
};
